/**
 * FEAT-004 helper — assigns a fresh cpid for the "Duplicate station"
 * action in the registry.
 *
 *   nextDuplicateCpid("CP01", ["CP01"])           → "CP01_2"
 *   nextDuplicateCpid("CP01", ["CP01","CP01_2"])  → "CP01_3"
 *   nextDuplicateCpid("CP01_2", [...])            → bumps the suffix on
 *                                                   the already-suffixed base
 *
 * Honors the OCPP cpid charset `[A-Za-z0-9_\-:.]` per
 * `data/snapshot-format.yaml` so the result is always reusable.
 */
export function nextDuplicateCpid(
  base: string,
  taken: readonly string[],
): string {
  // Peel off a trailing `_N` suffix if present so chained duplicates stay
  // compact (CP01 → CP01_2 → CP01_3 rather than CP01_2_2).
  const match = /^(.+?)_(\d+)$/.exec(base);
  const root = match?.[1] ?? base;
  const start = match?.[2] !== undefined ? Number(match[2]) + 1 : 2;
  const set = new Set(taken);
  for (let n = start; n < 1_000_000; n++) {
    const candidate = `${root}_${n}`;
    if (!set.has(candidate)) return candidate;
  }
  // Theoretical: a million collisions. Fall back to a timestamp tail.
  return `${root}_${Date.now()}`;
}
